<template>

    <div class="flex flex-col flex-1">

        <product-grid-base
            :products="products"
        ></product-grid-base>

    </div>

</template>

<script>

    import qs from 'qs'
    import ProductGridBase from './ProductGridBase.vue';

    export default {

        components: {
            ProductGridBase,
        },

        props: {

            dataUrl: String,

            sizes: {
                type: String,
                default: 'w-full md:w-1/2 lg:w-1/3 xl:w-1/5',
            },
            order: {
                type: String,
                default: 'desc',
            },
            category: {
                type: Number,
                required: false,
                default: 0
            },
            filter: {
                type: String,
                default: '',
            },
        },

        data() {

            return {
                products: [],
            }
        },

        computed: {   },

        mounted() {

            this.init();

        },

        methods: {

            init() {
                console.log('fetching');

                axios.get(this.dataUrl, {
                    'params': {
                        category: this.category,
                        order: this.order,
                        filter: this.filter,
                    },
                    'paramsSerializer': function(params) {
                         return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                })
                    .then(({ data }) => {

                        if (typeof data.data !== 'undefined') {
                            this.products = data.data;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })

            },

        },


        watch: {
            filter: function (newFilter, oldFilter) {
               this.init();
            },
         },
    }


</script>
